import { Form, router, usePage } from "@inertiajs/react";
import { useEffect, useState } from "react";
import { CompanySwitcher } from "@/components/company-switcher";
import { LanguageChoice } from "@/components/language-choice";
import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

export default function BillingNotice({ reason }: { reason: string }) {
  const { t } = useTranslation();
  const trial = reason === "trial_expired";
  const account = usePage().props.auth?.account?.id;
  const [open, setOpen] = useState(true);
  useEffect(() => setOpen(true), [account, reason]);
  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t(trial ? "recovery.trial_title" : "recovery.payment_title")}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t(
              trial
                ? "recovery.trial_description"
                : "recovery.payment_description",
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <LanguageChoice />
        <CompanySwitcher />
        <AlertDialogFooter>
          <Button variant="ghost" onClick={() => setOpen(false)}>
            {t("access.close_notice")}
          </Button>
          <Form action="/logout" method="delete">
            {({ processing }) => (
              <Button variant="outline" type="submit" disabled={processing}>
                {t("common.sign_out")}
              </Button>
            )}
          </Form>
          <Button onClick={() => router.post("/user/billing_notice")}>
            {t(trial ? "recovery.upgrade" : "recovery.update_payment")}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
